import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import { ClassroomPlayer, ClassroomPlayerFrame } from '@/components/custom/classroom';

export default function StepVideolesson(props) {
  const { step, createLessonForm, urlError, setIsSlide } = props;
  const [player, setPlayer] = useState('');
  const [videoId, setVideoId] = useState();

  const getPlayer = url => {
    const youtubeRegex = /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube(-nocookie)?\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/;
    const vimeoRegex = /(http|https)?:\/\/(www\.|player\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|video\/|)(\d+)(?:|\/\?)/;
    const geniallyRegex = /^(https?:\/\/view\.(genially\.com|genial\.ly)\/[\w\-]+)/;

    const youtubeResult = url?.match(youtubeRegex);
    const vimeoResult = url?.match(vimeoRegex);
    const geniallyResult = url?.match(geniallyRegex);

    if (youtubeResult) {
      setIsSlide(false);
      setPlayer('youtube');
      setVideoId(youtubeResult[6]);
    } else if (vimeoResult) {
      setIsSlide(false);
      setPlayer('vimeo');
      setVideoId(vimeoResult[4]);
    } else if (geniallyResult) {
      setIsSlide(true);
      setPlayer('genially');
      setVideoId(geniallyResult[0]);
      createLessonForm.setFieldValue('quizItemsAttributes', []);
    } else {
      setPlayer('');
      setVideoId(null);
    }
  };

  useEffect(() => {
    getPlayer(createLessonForm.values.url);
  }, [createLessonForm.values.url]);

  return (
    step === 'videoaula' && (
      <div className="page__content mb-12 animate-fade-in">
        <div className="new-questions__header">
          <h2 className="new-questions__title">{createLessonForm.values.body || t('textsCommon.lessonName')}</h2>
        </div>

        <div className="new-questions__body">
          <p className="new-questions__subtitle">{t('lessons.lessonVideoDescription')}</p>

          <div className="form__row">
            <label
              className="form__label"
              htmlFor="url"
            >
              {t('lessons.titleLinkVideoOrSlide')}
            </label>
            <input
              className="form__control"
              placeholder={t('lessons.placeholderSetLink')}
              id="url"
              name="url"
              type="url"
              value={createLessonForm.values.url}
              onChange={e => createLessonForm.setFieldValue('url', e.target.value)}
            />
            {urlError && <span style={{ color: 'red' }}>{urlError}</span>}
          </div>
          {createLessonForm.values.url && player === 'youtube' && (
            <ClassroomPlayer>
              <ClassroomPlayerFrame>
                <div>
                  <iframe
                    width="560"
                    height="315"
                    src={`https://www.youtube.com/embed/${videoId}`}
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen
                  />
                </div>
              </ClassroomPlayerFrame>
            </ClassroomPlayer>
          )}
          {createLessonForm.values.url && player === 'vimeo' && (
            <ClassroomPlayer>
              <ClassroomPlayerFrame>
                <div>
                  <iframe
                    src={`https://player.vimeo.com/video/${videoId}`}
                    width="560"
                    height="315"
                    frameborder="0"
                    allow="autoplay; fullscreen; picture-in-picture"
                    allowfullscreen
                  />
                </div>
              </ClassroomPlayerFrame>
            </ClassroomPlayer>
          )}
          {createLessonForm.values.url && player === 'genially' && (
            <ClassroomPlayer>
              <ClassroomPlayerFrame>
                <div>
                  <iframe
                    frameborder="0"
                    width="1200"
                    height="675"
                    style={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '100%' }}
                    src={videoId}
                    type="text/html"
                    allowscriptaccess="always"
                    allowfullscreen="true"
                    allownetworking="all"
                  />
                </div>
              </ClassroomPlayerFrame>
            </ClassroomPlayer>
          )}
        </div>
      </div>
    )
  );
}
